import React from "react";
import NavBar from "./Components/NavBar";

const App = (props) => {

  return (
    <div>
      <NavBar/>
    </div>
  )
}

export default App